<template>
  <b-row class="step goal flex-column">
    <header class="col col-md-9 d-flex align-items-center">
      <div class="number">4</div>
      <span class="text-primary medium">{{ labels.header }}</span>
    </header>
    <b-col cols="12" md="9" class="range-box" :class="{ 'd-none': hideGoal }">
      <input
        v-metric-color.update
        :data-metric-value="currentValue"
        type="range"
        :disabled="disabledInput"
        max="10"
        step="0.1"
        v-model="currentValue"
        class="slider"
      />

      <span class="text-center mt-1 bold">
        <span
          v-metric-color.update
          :data-metric-value="metric.score"
          class="label"
        >
          <small class="bold">{{ labels.current }}</small>
          {{ metric.score }}
        </span>
        |
        <span
          v-metric-color.update
          :data-metric-value="currentValue"
          class="label"
        >
          {{ currentValue }}
          <small class="bold">{{ labels.goal }}</small>
        </span>
      </span>
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    metric: {
      type: Object,
    },
    hideGoal: {
      type: Boolean,
    },
    disabledInput: {
      type: Boolean,
    },
    goal: {
      type: [Number, String],
    },
  },
  watch: {
    metric: {
      handler({ score }) {
        if (!isNaN(this.goal)) return false

        this.currentValue = score || this.currentValue
        this.$emit('change', this.currentValue)
      },
      immediate: true,
    },
    currentValue(value) {
      this.$emit('change', value)
    },
    goal: {
      handler(goal) {
        goal && (this.currentValue = goal)
      },
      immediate: true,
    },
  },
  data() {
    return {
      currentValue: undefined,
    }
  },
  computed: {
    labels() {
      return this.$store.getters.resources.component.actionPlan.formGoal
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

@mixin metricValueOnTrack($class, $value) {
  #{$class}::-webkit-slider-runnable-track {
    background-color: map-get($theme-colors, $value) !important;
  }

  #{$class}::-moz-range-track {
    background-color: map-get($theme-colors, $value) !important;
  }

  #{$class}::-ms-track {
    background-color: map-get($theme-colors, $value) !important;
  }
}

@include metricValueOnTrack('.metric-high', 'metric-high');
@include metricValueOnTrack('.metric-medium', 'metric-medium');
@include metricValueOnTrack('.metric-low', 'metric-low');

.range-box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    justify-content: space-between;
    padding-left: 0;
  }
}

input[type="range"].slider /* Usando esse seletor para que ele seja mais especifico que outros */ {
  background-color: map-get($theme-colors, 'white') !important;
  -webkit-appearance: none;
  height: 15px;
  margin: 10px 0;

  @include media-breakpoint-up(md) {
    width: 450px;
  }

  &:focus {
    outline: none;
  }

  &::-webkit-slider-runnable-track {
    animate: 0.2s;
    background-color: map-get($theme-colors, 'gray01');
    border-radius: 50px;
    border: 1px solid map-get($theme-colors, 'gray01');
    cursor: pointer;
    height: 10px;
    width: 100%;
  }

  &:focus::-webkit-slider-runnable-track {
    background-color: map-get($theme-colors, 'gray01');
  }

  &::-moz-range-track {
    animate: 0.2s;
    background-color: map-get($theme-colors, 'gray01');
    border-radius: 50px;
    border: 1px solid map-get($theme-colors, 'black');
    cursor: pointer;
    height: 10px;
    width: 100%;
  }

  &::-ms-track {
    animate: 0.2s;
    background: transparent;
    border-color: transparent;
    color: transparent;
    cursor: pointer;
    height: 10px;
    width: 100%;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: map-get($theme-colors, 'white');
    border: 8px solid map-get($theme-colors, 'primary');
    border-radius: 50px;
    box-shadow: 1px 1px 1px map-get($theme-colors, 'black');
    cursor: pointer;
    height: 23px;
    margin-top: -7.5px;
    width: 22px;
  }

  &::-ms-thumb {
    background-color: map-get($theme-colors, 'white');
    box-shadow: 1px 1px 1px map-get($theme-colors, 'black');
    border: 1px solid map-get($theme-colors, 'black');
    border-radius: 50px;
    cursor: pointer;
    height: 23px;
    margin-top: 7.5px;
    width: 22px;
  }

  &::-moz-range-thumb {
    background-color: map-get($theme-colors, 'white');
    box-shadow: 1px 1px 1px map-get($theme-colors, 'black');
    border: 1px solid map-get($theme-colors, 'black');
    border-radius: 50px;
    cursor: pointer;
    height: 23px;
    width: 22px;
  }

  &::-ms-fill-lower {
    background-color: map-get($theme-colors, 'gray01');
    border: 1px solid map-get($theme-colors, 'black');
    border-radius: 100px;
    box-shadow: 1px 1px 1px map-get($theme-colors, 'black');
  }

  &:focus::-ms-fill-lower {
    background-color: map-get($theme-colors, 'gray01');
  }

  &::-ms-fill-upper {
    background-color: map-get($theme-colors, 'gray01');
    border: 1px solid map-get($theme-colors, 'black');
    border-radius: 100px;
    box-shadow: 1px 1px 1px map-get($theme-colors, 'black');
  }

  &:focus::-ms-fill-upper {
    background-color: map-get($theme-colors, 'gray01');
  }
}
</style>
